(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arc-collection-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = scope => scope.querySelectorAll('[data-directory]').forEach(root => {
  if(root.dataset.ready) return;
  root.dataset.ready = 'true';
  const panels = [...root.querySelectorAll('[data-panel]')], choices = [...root.querySelectorAll('[data-choice]')];
  if(!panels.length) return;
  root.classList.add('acd-ready');
  const belt = root.querySelector('.acd-belt'), view = root.querySelector('[data-view]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false, active = '';
  const update = () => {
   ticking = false;
   if(!root.isConnected) {belt.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);return;}
   const center = belt.getBoundingClientRect().top + belt.clientHeight * .5;
   let nearest = panels[0], distance = Infinity;
   panels.forEach(panel => {
    const bounds = panel.getBoundingClientRect(), d = Math.abs(bounds.top + bounds.height / 2 - center);
    if(d < distance){nearest=panel;distance=d;}

   });
   if(active !== nearest.dataset.panel){active = nearest.dataset.panel;choices.forEach(choice=>{choice.setAttribute('aria-current',String(choice.dataset.choice===active));if(choice.dataset.choice===active)view.href=choice.dataset.url;});}
  };
  const schedule = () => {if(!ticking){ticking=true;requestAnimationFrame(update);}};
  root.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-panel]');if(panel)belt.scrollTo({top:panel.offsetTop,behavior:'auto'});});
  const selector = root.querySelector('.acd-selector');
  let lastStep = 0, wheelTotal = 0;
  const step = direction => {
   const current=panels.findIndex(panel=>panel.dataset.panel===active);
   const next=panels[Math.max(0,Math.min(panels.length-1,current+direction))];
   belt.scrollTo({top:next.offsetTop,behavior:reduced.matches?'auto':'smooth'});
  };
  selector.addEventListener('wheel',event => {
   if(event.ctrlKey || Math.abs(event.deltaX)>Math.abs(event.deltaY)) return;
   event.preventDefault();
   if(Date.now()-lastStep<700)return;
   wheelTotal+=event.deltaY*(event.deltaMode===1?16:event.deltaMode===2?belt.clientHeight:1);
   if(Math.abs(wheelTotal)>=40){step(Math.sign(wheelTotal));wheelTotal=0;lastStep=Date.now();}
  },{passive:false});
  let touchY = null, touchDelta = 0;
  selector.addEventListener('touchstart',event=>{touchY=event.touches.length===1?event.touches[0].clientY:null;touchDelta=0;},{passive:true});
  selector.addEventListener('touchmove',event=>{
   if(touchY===null || event.touches.length!==1)return;
   touchDelta=touchY-event.touches[0].clientY;
   if(Math.abs(touchDelta)>8)event.preventDefault();
  },{passive:false});
  selector.addEventListener('touchend',()=>{if(Math.abs(touchDelta)>35)step(Math.sign(touchDelta));touchY=null;touchDelta=0;},{passive:true});
  selector.addEventListener('keydown',event=>{
   const steps={ArrowDown:1,ArrowUp:-1,PageDown:1,PageUp:-1};
   if(!(event.key in steps))return;
   event.preventDefault();
   const current=panels.findIndex(panel=>panel.dataset.panel===active);
   const next=panels[Math.max(0,Math.min(panels.length-1,current+steps[event.key]))];
   belt.scrollTo({top:next.offsetTop,behavior:reduced.matches?'auto':'smooth'});
  });
  belt.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);update();
 });
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));else initialize(document);
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-editorial-header"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = () => document.querySelectorAll('[data-arc-header]').forEach(root => {
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const toggle=root.querySelector('#shop-toggle'),menu=root.querySelector('#shop-menu'),scrim=root.querySelector('.scrim'),mobile=root.querySelector('#mobile-menu'),search=root.querySelector('#search');
  const controller=new AbortController(),opts={signal:controller.signal};
  const close=()=>{menu.hidden=true;scrim.hidden=true;toggle.setAttribute('aria-expanded','false')};
  const updateScroll=()=>root.classList.toggle('arc-header-scrolled',window.scrollY>32);
  window.addEventListener('scroll',updateScroll,{...opts,passive:true});updateScroll();
  const measure=()=>{
   const header=root.querySelector('.header');
   root.style.setProperty('--arc-menu-top',header.getBoundingClientRect().bottom+'px');
   document.body.style.setProperty('--header-height',root.getBoundingClientRect().height+'px');
   document.body.style.setProperty('--header-group-height',root.getBoundingClientRect().height+'px');
  };
  toggle.addEventListener('click',()=>{const open=menu.hidden;menu.hidden=!open;scrim.hidden=!open;toggle.setAttribute('aria-expanded',String(open));measure()},opts);
  scrim.addEventListener('click',close,opts);
  root.addEventListener('keydown',e=>{if(e.key==='Escape'&&!menu.hidden){close();toggle.focus()}},opts);
  root.addEventListener('focusout',()=>requestAnimationFrame(()=>{if(!root.contains(document.activeElement))close()}),opts);
  root.querySelector('#mobile-open').addEventListener('click',()=>mobile.showModal(),opts);
  root.querySelector('[data-search]').addEventListener('click',()=>{close();search.showModal()},opts);
  root.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close(),opts));
  window.addEventListener('resize',()=>{close();if(innerWidth>=990&&mobile.open)mobile.close();measure()},opts);
  window.addEventListener('scroll',()=>{if(!menu.hidden)measure()},{...opts,passive:true});
  const observer=new ResizeObserver(measure);observer.observe(root);measure();
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){observer.disconnect();controller.abort()}},opts);
 });
 init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-home-edge"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = () => document.querySelectorAll('.arc-edge-panel').forEach(panel => {
  const video = panel.querySelector('.arc-edge-video'), button = panel.querySelector('.arc-edge-video-toggle');
  if (!video || !button || video.dataset.ready) return;
  video.dataset.ready = 'true';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let manualPause = false;
  const playLabel = button.textContent.trim(), pauseLabel = button.dataset.pauseLabel;
  const update = () => { const label = video.paused ? playLabel : pauseLabel; button.textContent = label; button.setAttribute('aria-label', label); };
  const controller = new AbortController(), options = { signal: controller.signal };
  const play = () => { video.play().catch(update); };
  video.addEventListener('play', update, options); video.addEventListener('pause', update, options);
  button.addEventListener('click', () => { if(video.paused){manualPause=false;play();}else{manualPause=true;video.pause();} }, options);
  const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting && !motion.matches && !manualPause){play();}else{video.pause();} }), {threshold:0.15});
  observer.observe(panel);
  motion.addEventListener('change', () => { if(motion.matches)video.pause(); }, options);
  document.addEventListener('shopify:section:unload', event => { if(event.target.contains(panel)){observer.disconnect();video.pause();controller.abort();} }, options);
  update();
 });
 init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-home-footer"]) return;
  try {
    (()=>{const init=()=>{const mq=matchMedia('(max-width:749px)');document.querySelectorAll('[data-arc-footer]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const update=()=>root.querySelectorAll('details').forEach(d=>d.open=!mq.matches);mq.addEventListener('change',update);update()})};init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-levelup-details"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const init=()=>document.querySelectorAll('[data-lu-tabs]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const bar=root.querySelector('.lu-tab-buttons'),buttons=[...bar.querySelectorAll('[data-tab]')],panels=[...root.querySelectorAll('[data-panel]')];
  bar.hidden=false;bar.setAttribute('role','tablist');bar.setAttribute('aria-label',root.querySelector('h2').textContent);root.classList.add('lu-tabs-ready');
  const select=(index,focus=false)=>{buttons.forEach((button,i)=>{const panel=panels.find(p=>p.dataset.panel===button.dataset.tab);button.setAttribute('role','tab');button.setAttribute('aria-selected',String(i===index));button.setAttribute('aria-controls',panel.id);button.tabIndex=i===index?0:-1;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.tabIndex=0;panel.hidden=i!==index});if(focus)buttons[index].focus()};
  buttons.forEach((button,index)=>{button.addEventListener('click',()=>select(index));button.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%buttons.length;if(event.key==='ArrowLeft')next=(index+buttons.length-1)%buttons.length;if(event.key==='Home')next=0;if(event.key==='End')next=buttons.length-1;if(next!==undefined){event.preventDefault();select(next,true)}})});
  root.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-panel]');if(panel)select(buttons.findIndex(b=>b.dataset.tab===panel.dataset.panel))});select(0);
 });init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-recovery-details"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const init=()=>document.querySelectorAll('[data-lu-tabs]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const bar=root.querySelector('.lu-tab-buttons'),buttons=[...bar.querySelectorAll('[data-tab]')],panels=[...root.querySelectorAll('[data-panel]')];
  bar.hidden=false;bar.setAttribute('role','tablist');bar.setAttribute('aria-label',root.querySelector('h2').textContent);root.classList.add('lu-tabs-ready');
  const select=(index,focus=false)=>{buttons.forEach((button,i)=>{const panel=panels.find(p=>p.dataset.panel===button.dataset.tab);button.setAttribute('role','tab');button.setAttribute('aria-selected',String(i===index));button.setAttribute('aria-controls',panel.id);button.tabIndex=i===index?0:-1;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.tabIndex=0;panel.hidden=i!==index});if(focus)buttons[index].focus()};
  buttons.forEach((button,index)=>{button.addEventListener('click',()=>select(index));button.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%buttons.length;if(event.key==='ArrowLeft')next=(index+buttons.length-1)%buttons.length;if(event.key==='Home')next=0;if(event.key==='End')next=buttons.length-1;if(next!==undefined){event.preventDefault();select(next,true)}})});
  root.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-panel]');if(panel)select(buttons.findIndex(b=>b.dataset.tab===panel.dataset.panel))});select(0);
 });init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
